import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from '@app/modules/table/table.module';
import { PlatformModule } from '@app/platform.module';
import { ApplicantTrackerResolver } from '@applicant-tracker/applicant-tracker.resolver';
import { ApplicantTrackerRouterModule } from '@applicant-tracker/applicant-tracker.routes';
import { Components, JobBoardIntegrationsV2Component } from '@applicant-tracker/components';
import { Services } from '@applicant-tracker/services';
import { ApplicantMessageTemplatesIndexTable } from '@applicant-tracker/services/tables/applicant-message-templates-table/applicant-message-templates-index.table';
import { ApplicantsIndexTable } from '@applicant-tracker/services/tables/applicants-table/applicants-index.table';
import { JobPostingApplicantsIndexTable } from '@applicant-tracker/services/tables/applicants-table/job-posting-applicants-index.table';
import { Views } from '@applicant-tracker/views';
import { AppCommonModule } from '@common/common.module';
import { MentionModule } from 'angular-mentions';
import { ApplicantTrackerFormsModule } from '../forms/applicant-tracker/applicant-tracker-forms.module';
import { DraftJobPostingRedirectGuard } from './guards/draft-job-posting.guard';
import { MenuServices } from './services/menus';

@NgModule({
    imports: [
        ApplicantTrackerRouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AppCommonModule,
        PlatformModule,
        TableModule,
        ApplicantTrackerFormsModule,
        DragDropModule,
        ScrollingModule,
        MentionModule,
        JobBoardIntegrationsV2Component,
    ],
    declarations: [...Views, ...Components],
    providers: [
        ApplicantTrackerResolver,
        ApplicantsIndexTable,
        JobPostingApplicantsIndexTable,
        ApplicantMessageTemplatesIndexTable,
        DraftJobPostingRedirectGuard,
        ...MenuServices,
        ...Services,
    ],
})
export class ApplicantTrackerModule {}
